<template>
  <transition-group mode="out-in">
    <div
      key="showing"
      v-if="ctaActive"
      class="animateLeft finderCTA w-full bg-purple-700 relative px-8 pt-8 rounded-lg rounded-b-none"
    >
      <div @click="toggleCTA" class="close">
        <i class="material-icons text-white">
          highlight_off
        </i>
      </div>
      <div class="max-w-4xl m-auto flex">
        <div class="w-full md:w-2/3">
          <router-link :to="{ name: 'Finder' }">
            <h3
              class="text-white text-2xl text-center font-semibold leading-tight mb-5"
            >
              Need help finding your ideal Au Pair?
            </h3>

            <p class="text-white text-lg text-center leading-tight mb-8">
              Answer a personalized questionnaire and let us recommend your most
              compatible Au Pairs.
            </p>
          </router-link>
        </div>

        <div class="img-container relative w-1/3">
          <img
            src="../../assets/img/aupair-cta.png"
            class="animeLeft cta-image"
            alt="Would you like CHI to help you find the most compatible Au Pair for your family?"
          />
        </div>
      </div>
    </div>
    <div
      key="hiding"
      @click="toggleCTA"
      class="toggleCTA flex items-center justify-center"
      v-else
    >
      <i class="material-icons text-4xl text-white">
        find_in_page
      </i>
    </div>
  </transition-group>
</template>

<script>
export default {
  name: "FinderCTA",
  data() {
    return {
      ctaActive: true,
    };
  },
  methods: {
    toggleCTA() {
      this.ctaActive = !this.ctaActive;
      window.localStorage.setItem("compatibilityCTA", this.ctaActive);
    },
  },
  created() {
    let ctaActive = window.localStorage.getItem("compatibilityCTA");
    if (ctaActive === null) this.ctaActive = true;
    else {
      ctaActive === "true" ? (this.ctaActive = true) : (this.ctaActive = false);
    }
  },
};
</script>

<style scoped lang="scss">
.finderCTA {
  position: fixed;
  bottom: 0;
  z-index: 9999;

  .cta-image {
    position: absolute;
    right: 10px;
    bottom: 0;
  }
}

@media screen and (max-width: 767px) {
  .img-container {
    display: none;
  }
}

.toggleCTA {
  position: fixed;
  right: 15px;
  bottom: 15px;
  @apply bg-purple-700;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  cursor: pointer;
}

.close {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
</style>
